(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalOverlayLinks = {
    attach(context) {
      const $openModalBtn = $("a.overlay", context);
      $openModalBtn.css("pointer-events", "auto"); // Reset the "pointer-events" attribute set in CSS before the click event is triggered.
      Drupal.behaviors.questionModalOverlayLinks.checkLinksClick(
        context,
        $openModalBtn
      ); // Add overlay functionality to the links
    },

    checkLinksClick(context, link) {
      // Handle link clicks
      link.once().each(function () {
        $(this).on("click", function (event) {
          event.preventDefault(); // Prevent default link behavior

          // Close modal if the link is within the "more like this" view
          if (
            $(this).closest(
              ".view-display-id-english_guides_more_like_this_block"
            ).length > 0
          ) {
            $("button.close").trigger("click");
          }

          const href = $(this).attr("href"); // Get the page URL to load
          const rel = $(this).attr("rel"); // Get the new page group
          Drupal.behaviors.questionModalOverlayLinks.updateHash(rel);
          Drupal.behaviors.questionModalOverlayLinks.loadPage(href);
          document.body.style.overflow = "hidden"; // Prevent page scrolling behind modal
        });
      });

      // Handle modal hide event
      $("#overlay-wrap", context)
        .once("questionModalHide")
        .on("hide.bs.modal", () => {
          document.body.style.overflow = "visible";
        });

      // Handle browser history changes
      $(window).on("popstate", () => {
        const $modal = $("#overlay-wrap");

        if ($modal.hasClass("show")) {
          // Trigger the close button click if the modal is open
          $("button.close", $modal).trigger("click");
        }
      });
    },

    // Update the hash after the content has changed
    updateHash(page) {
      const url = new URL(window.location.href);
      if (url.pathname === "/plan/modules") {
        return;
      }
      const pageHash = "#page=" + page; // Add page hash
      history.pushState(null, null, pageHash);
    },

    // Load the content via AJAX and animate the overlay
    loadPage(href, rel) {
      const endpoint = Drupal.url.toAbsolute(href); // Convert the href to an absolute URL.
      $("body").after(Drupal.theme.ajaxProgressIndicatorFullscreen()); // Show the throbber.
      Drupal.ajax({ url: endpoint }).execute(); // Execute AJAX call.
    },
  };
})(jQuery, Drupal);
